import { Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { getCompanies } from 'api/companies';
import { updateCustomer } from 'api/customers';
import { getData } from 'utils';
import { captureException } from 'utils/errors';
import { getHttpErrorMessage } from 'utils/http';
import { App } from 'antd';

function AssignCompanyModal({ open, customer, onClose, onSuccess }) {
  const [companies, setCompanies] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const { message } = App.useApp();

  useEffect(() => {
    if (open) {
      setSelectedCompanyId(customer?.company ?? customer?.company_detail?.id ?? null);
      setLoading(true);
      getCompanies()
        .then((res) => {
          const data = getData(res);
          const results = data?.data?.results ?? data?.results ?? (Array.isArray(data) ? data : []);
          setCompanies(Array.isArray(results) ? results : []);
        })
        .catch(captureException)
        .finally(() => setLoading(false));
    }
  }, [open, customer?.company, customer?.company_detail?.id]);

  const handleOk = () => {
    setSaving(true);
    const selectedCompany = companies.find((c) => c.id === selectedCompanyId);
    updateCustomer(customer.id, { company: selectedCompanyId || null })
      .then((res) => {
        const data = getData(res)?.data ?? getData(res) ?? res?.data ?? res;
        onSuccess?.({
          ...data,
          company_detail: selectedCompany
            ? { id: selectedCompany.id, name: selectedCompany.name, industry: selectedCompany.industry }
            : null,
        });
        message.success('Company assignment updated');
        onClose();
      })
      .catch((e) => {
        captureException(e);
        message.error(getHttpErrorMessage(e));
      })
      .finally(() => setSaving(false));
  };

  return (
    <Modal
      title="Assign to Company"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={saving}
      destroyOnClose
    >
      <Select
        style={{ width: '100%' }}
        placeholder="Select a company"
        loading={loading}
        value={selectedCompanyId}
        onChange={setSelectedCompanyId}
        allowClear
        showSearch
        optionFilterProp="label"
        options={[
          { value: null, label: '— No company —' },
          ...companies.map((c) => ({ value: c.id, label: c.name })),
        ]}
      />
    </Modal>
  );
}

export default AssignCompanyModal;
